import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import logo from "../../assets/img/btc.png"
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";
// core components
import { useTranslation } from 'react-i18next';

const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};


function WhiteNavbar() {
  const { t, i18n } = useTranslation();


  const [bodyClick, setBodyClick] = React.useState(false);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  });
  return (
    <>

      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}

      <Navbar className="fixed-top" expand="lg" id="navbar-main" color="danger">
      <Container>

        <div className="navbar-translate">
          <NavbarBrand id="navbar-brand" to="/" tag={Link}>
            <img src={logo} height="55vh"/>
          </NavbarBrand>
          <UncontrolledTooltip placement="bottom" target="navbar-brand">
          {  t('description.part27')}

          </UncontrolledTooltip>
          <button
            className="navbar-toggler"
            id="navigation"
            type="button"
            onClick={() => {
              document.documentElement.classList.toggle("nav-open");
              setBodyClick(true);
              setCollapseOpen(true);
            }}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse navbar isOpen={collapseOpen}>
          <Nav className="ml-auto" navbar>
          <UncontrolledDropdown nav inNavbar>
              <DropdownToggle   to="/" tag={Link} className="mr-2" color="default"  nav>
                Home
              </DropdownToggle>
              {/* <DropdownMenu className="dropdown-danger" right>
                <DropdownItem to="/sections#headers" tag={Link}>
                  <i className="nc-icon nc-tile-56" />
                  Headers
                </DropdownItem>
                <DropdownItem to="/sections#features" tag={Link}>
                  <i className="nc-icon nc-settings" />
                  Features
                </DropdownItem>
                <DropdownItem to="/sections#blogs" tag={Link}>
                  <i className="nc-icon nc-bullet-list-67" />
                  Blogs
                </DropdownItem>
                <DropdownItem to="/sections#teams" tag={Link}>
                  <i className="nc-icon nc-single-02" />
                  Teams
                </DropdownItem>
                <DropdownItem to="/sections#projects" tag={Link}>
                  <i className="nc-icon nc-calendar-60" />
                  Projects
                </DropdownItem>
                <DropdownItem to="/sections#pricing" tag={Link}>
                  <i className="nc-icon nc-money-coins" />
                  Pricing
                </DropdownItem>
                <DropdownItem to="/sections#testimonials" tag={Link}>
                  <i className="nc-icon nc-badge" />
                  Testimonials
                </DropdownItem>
                <DropdownItem to="/sections#contact-us" tag={Link}>
                  <i className="nc-icon nc-mobile" />
                  Contact Us
                </DropdownItem>
              </DropdownMenu> */}
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle className="mr-2"  color="default" caret   nav>
              {t('description.part28')}

              </DropdownToggle>
              <DropdownMenu className="dropdown-danger" right>
                <DropdownItem to="/gallery" tag={Link}>
                  <i className="nc-icon nc-tile-56" />
                  Gallery
                </DropdownItem>
                <DropdownItem to="/about-us" tag={Link}>
                  <i className="nc-icon nc-badge" />
                  About
                </DropdownItem>
                {/* <DropdownItem to="/sections#blogs" tag={Link}>
                  <i className="nc-icon nc-bullet-list-67" />
                  Blogs
                </DropdownItem>
                <DropdownItem to="/sections#teams" tag={Link}>
                  <i className="nc-icon nc-single-02" />
                  Teams
                </DropdownItem>
                <DropdownItem to="/sections#projects" tag={Link}>
                  <i className="nc-icon nc-calendar-60" />
                  Projects
                </DropdownItem>
                <DropdownItem to="/sections#pricing" tag={Link}>
                  <i className="nc-icon nc-money-coins" />
                  Pricing
                </DropdownItem>
                <DropdownItem to="/sections#testimonials" tag={Link}>
                  <i className="nc-icon nc-badge" />
                  Testimonials
                </DropdownItem>
                <DropdownItem to="/sections#contact-us" tag={Link}>
                  <i className="nc-icon nc-mobile" />
                  Contact Us
                </DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle className="mr-2" color="default" caret nav>
                Tours
              </DropdownToggle>
              <DropdownMenu className="dropdown-danger" right>
              <DropdownItem to="/chivatour" tag={Link}>
                CITY TOUR EN CHIVA
                </DropdownItem>
                <DropdownItem to="/playablanca" tag={Link}>
                PLAYA BLANCA
                </DropdownItem>
                <DropdownItem
                  to="/cuatroislas" tag={Link}
                >
                  CUATRO ISLAS + PLANCTON
                </DropdownItem>   <DropdownItem
to="/gentedemar" tag={Link}                >
                  GENTE DE MAR
                </DropdownItem>   <DropdownItem
to="/palmarito" tag={Link}                >
                  PALMARITO BEACH
                </DropdownItem>   <DropdownItem
to="/bahia" tag={Link}                >
                  TOUR BAHIA
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
        
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle color="default" to="https://checkout.wompi.co/l/JXJM61" tag={Link} nav>
              {t('description.part29')}

              </DropdownToggle>
              {/* <DropdownMenu className="dropdown-danger" right>
                <DropdownItem to="/about-us" tag={Link}>
                  <i className="nc-icon nc-bank" />
                  About-us
                </DropdownItem>
                <DropdownItem to="/add-product" tag={Link}>
                  <i className="nc-icon nc-basket" />
                  Add Product
                </DropdownItem>
                <DropdownItem to="/blog-post" tag={Link}>
                  <i className="nc-icon nc-badge" />
                  Blog Post
                </DropdownItem>
                <DropdownItem to="/blog-posts" tag={Link}>
                  <i className="nc-icon nc-bullet-list-67" />
                  Blog Posts
                </DropdownItem>
                <DropdownItem to="/contact-us" tag={Link}>
                  <i className="nc-icon nc-mobile" />
                  Contact Us
                </DropdownItem>
                <DropdownItem to="/discover" tag={Link}>
                  <i className="nc-icon nc-world-2" />
                  Discover
                </DropdownItem>
                <DropdownItem to="/e-commerce" tag={Link}>
                  <i className="nc-icon nc-send" />
                  Ecommerce
                </DropdownItem>
                <DropdownItem to="/landing-page" tag={Link}>
                  <i className="nc-icon nc-spaceship" />
                  Landing Page
                </DropdownItem>
                <DropdownItem to="/login-page" tag={Link}>
                  <i className="nc-icon nc-lock-circle-open" />
                  Login Page
                </DropdownItem>
                <DropdownItem to="/product-page" tag={Link}>
                  <i className="nc-icon nc-album-2" />
                  Product Page
                </DropdownItem>
                <DropdownItem to="/profile-page" tag={Link}>
                  <i className="nc-icon nc-single-02" />
                  Profile Page
                </DropdownItem>
                <DropdownItem to="/register-page" tag={Link}>
                  <i className="nc-icon nc-bookmark-2" />
                  Register Page
                </DropdownItem>
                <DropdownItem to="/search-with-sidebar" tag={Link}>
                  <i className="nc-icon nc-zoom-split" />
                  Search Page
                </DropdownItem>
                <DropdownItem to="/settings" tag={Link}>
                  <i className="nc-icon nc-settings-gear-65" />
                  Settings Page
                </DropdownItem>
                <DropdownItem to="/twitter-redesign" tag={Link}>
                  <i className="nc-icon nc-tie-bow" />
                  Twitter
                </DropdownItem>
              </DropdownMenu> */}
            </UncontrolledDropdown>
            <NavItem>
              <Button
                className="btn-round"
                color="danger"
                href="/contact-us"
              >
                <i className="nc-icon nc-tap-01" />               {t('description.part5')}

              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
      </Navbar>

    </>
  );
}

export default WhiteNavbar;
